export default __webpack_public_path__ + "static/media/logoKSR.c2e0b703.jpg";